import React, { useEffect, useMemo, useState } from "react";
import { Slider } from "@blueprintjs/core";
import TextTruncate from "components/TextTruncate";
import useDebounce from "hooks/useDebounce";
import * as styles from "../Slider/styles.module.scss";
const MAX_SPACEVIEWER_POINTS_NUMBER = 500;
const MIN_DENSITY_POINTS_NUMBER = 2;
const Density = ({ data, isEmpty, changeDensity }) => {
    const [densitySliderValue, setDensitySliderValue] = useState(data?.source?.density ?? data?.values?.length ?? MAX_SPACEVIEWER_POINTS_NUMBER);
    const [debouncedDensityValue, setDebouncedDensityValue] = useState();
    const densityValue = useDebounce(debouncedDensityValue, 300);
    const maxSliderValue = useMemo(() => data.maxPointsNumber ?? MAX_SPACEVIEWER_POINTS_NUMBER, [data.maxPointsNumber]);
    const minSliderValue = useMemo(() => (MIN_DENSITY_POINTS_NUMBER === maxSliderValue ? 0 : MIN_DENSITY_POINTS_NUMBER), [maxSliderValue]);
    const safeValue = useMemo(() => {
        const value = data.values?.length ? densitySliderValue : 0;
        return value < minSliderValue ? minSliderValue : value > maxSliderValue ? maxSliderValue : value;
    }, [data.values?.length, densitySliderValue, maxSliderValue, minSliderValue]);
    useEffect(() => {
        if (densityValue === densitySliderValue && densityValue === debouncedDensityValue) {
            changeDensity && changeDensity(densityValue);
            setDebouncedDensityValue(0);
        }
    }, [changeDensity, setDebouncedDensityValue, densitySliderValue, densityValue, debouncedDensityValue]);
    return (React.createElement("div", { className: styles["slider-wrapper"] },
        React.createElement("div", { className: styles.label },
            React.createElement("div", { className: styles["name-wrapper"] },
                React.createElement(TextTruncate, { text: "Density", className: styles.name })),
            React.createElement("div", null, data.values?.length ? densitySliderValue : 0)),
        React.createElement(Slider, { value: safeValue, initialValue: densitySliderValue, onChange: (value) => {
                setDensitySliderValue(value);
                setDebouncedDensityValue(value);
            }, labelStepSize: maxSliderValue <= minSliderValue ? minSliderValue : maxSliderValue - minSliderValue, stepSize: 1, min: minSliderValue, max: maxSliderValue, showTrackFill: false, className: styles.slider, disabled: isEmpty || MIN_DENSITY_POINTS_NUMBER === maxSliderValue })));
};
export default Density;
